module.exports = __webpack_public_path__ + "static/podcast-67b30036aec33c2fdfe80f92c1b4a1fd.png";